import React, { useEffect, useRef } from 'react'
import PageHeading from '../../../../components/PageHeading'
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';

export default function ProjectOver({ projectData }) {

    const chartRef = useRef(null);
     const formattedValue = projectData?.plottedLandArea 
            ? (Number(projectData.plottedLandArea) % 1 === 0 
                ? projectData.plottedLandArea.toString() 
                : Number(projectData.plottedLandArea).toFixed(2))
            : '0';
    // useEffect(() => {
    //     // console.log("projectData.totalLandArea", projectData.totalLandArea)
    //     if (chartRef.current) {
    //         const chart = chartRef.current.chart;

    //         // Calculate the exact center of the plot area
    //         const centerX = (chart.plotWidth / 3) + chart.plotLeft;
    //         const centerY = (chart.plotHeight / 2.5) + chart.plotTop;
    //         const center1X = (chart.plotWidth / 2.5) + chart.plotLeft;
    //         const center1Y = (chart.plotHeight / 2) + chart.plotTop;

    //         // Add a custom label in the center
    //         chart.renderer
    //             .label('Total Area', centerX, centerY)
    //             .attr({
    //                 zIndex: 99,
    //             })
    //             .css({
    //                 color: '#000',
    //                 fontSize: '18px',
    //                 fontWeight: "600"
    //             })
    //             .add();

    //         chart.renderer
    //             // .label(projectData.totalLandArea, center1X, center1Y)
    //             .label(1000000, center1X, center1Y)
    //             .attr({
    //                 zIndex: 99,
    //             })
    //             .css({
    //                 color: '#000',
    //                 fontSize: '20px',
    //                 fontWeight: "800"
    //             })
    //             .add();
    //     }
    // }, [projectData]);
    useEffect(() => {
        if (chartRef.current) {
            const chart = chartRef.current.chart;

            // Remove previous custom labels if they exist
            if (chart.customLabel1) {
                chart.customLabel1.destroy();
            }
            if (chart.customLabel2) {
                chart.customLabel2.destroy();
            }

            // Calculate the exact center of the plot area
            const centerX = (chart.plotWidth / 2) + chart.plotLeft;
            const centerY = (chart.plotHeight / 2) + chart.plotTop;

            // Add "Total Area" label
            chart.customLabel1 = chart.renderer
                .text('Plotted Area', 0, 0)
                .css({
                    color: '#000',
                    fontSize: '18px',
                    fontWeight: "600"
                })
                .add();

            // Get label dimensions and center it
            const bbox1 = chart.customLabel1.getBBox();
            chart.customLabel1.attr({
                x: centerX - (bbox1.width / 2),
                y: centerY - 10,
                zIndex: 99
            });

            // Add area value label
            chart.customLabel2 = chart.renderer
                // .text(projectData?.totalLandArea?.toString(), 0, 0)
                .text(formattedValue)
                .css({
                    color: '#000',
                    fontSize: '20px',
                    fontWeight: "800"
                })
                .add();

            // Get label dimensions and center it
            const bbox2 = chart.customLabel2.getBBox();
            chart.customLabel2.attr({
                x: centerX - (bbox2.width / 2),
                y: centerY + 15,
                zIndex: 99
            });
        }
    }, [projectData]);
    const options = {
        chart: {
            type: 'pie',
        },
        title: {
            text: '',
        },
        plotOptions: {
            pie: {
                innerSize: '70%',
                dataLabels: {
                    enabled: false,
                },
            },
            borderRadius: 600,
        },
        series: [
            {
                name: 'Amount',
                data: [
                    { name: 'Total Land Cost', y: projectData && projectData.totalLandPrice && parseFloat(projectData.totalLandPrice.split(" ")[0]), color: '#006CFF' },
                    { name: 'Total amount from booking', y: 0, color: '#FE996C' },
                    { name: 'Sale Amount received', y: 0, color: '#03D4C6' },
                    { name: 'Amount left to be received', y: 0, color: '#F15642' },
                ],
            },
        ],
    };

    return (
        <div className='container-fluid landformconatiner p-4'>
            <PageHeading pagename="Project Overview" />
            <div className='row' style={{ height: "350px" }}>
                <HighchartsReact highcharts={Highcharts} options={options} ref={chartRef} />
            </div>

            <div className='d-flex flex-column gap-3 pt-3'>
                <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div style={{ width: "15px", height: "15px", backgroundColor: "#006CFF", borderRadius: "15px" }}></div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Plotted Area</label>
                            <label className='sub-heading-project' >{projectData.plottedLandArea?.toFixed(2)} {projectData.plottedLandArea?(projectData.unitName === "SquareFoot" ? "Sq" : projectData.unitName):'-'}</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename={"₹ " + projectData.totalLandPrice} />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-between  pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div style={{ width: "15px", height: "15px", backgroundColor: "#FFFFFF", borderRadius: "15px",border:'1px solid black' }}></div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Available Area</label>
                            <label className='sub-heading-project' >{projectData.availableArea?(projectData.availablearea).toFixed(2):'-'}{projectData.plottedLandArea?(projectData.unitName === "SquareFoot" ? "Sq" : projectData.unitName):''}</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="₹ 0" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-between  pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div style={{ width: "15px", height: "15px", backgroundColor: "#8DC86C", borderRadius: "15px" }}></div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Sold Area</label>
                            <label className='sub-heading-project'>{projectData.saleArea?(projectData.saleArea).toFixed(2):'-'}{projectData.plottedLandArea?(projectData.unitName === "SquareFoot" ? "Sq" : projectData.unitName):''}</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="₹ 0" />
                    </div>
                </div>
                <div className='d-flex flex-row justify-content-between pb-2 rowBox' >
                    <div className='d-flex flex-row gap-2'>
                        <div style={{ width: "15px", height: "15px", backgroundColor: "#FEFA99", borderRadius: "15px" }}></div>
                        <span className='d-flex flex-column '>
                            <label className='heading-project fw-semibold'>Booked Area</label>
                            <label className='sub-heading-project'>{projectData.bookedArea?(projectData.bookedArea).toFixed(2):'-'}{projectData.plottedLandArea?(projectData.unitName === "SquareFoot" ? "Sq" : projectData.unitName):''}</label>
                        </span>
                    </div>
                    <div className='d-flex flex-row'>
                        <PageHeading pagename="₹ 0" />
                    </div>
                </div>
            </div>
        </div>
    )
}

